"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _NavigateNext = _interopRequireDefault(require("@mui/icons-material/NavigateNext"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _contexts = require("../../config/contexts");
var _classnames = _interopRequireDefault(require("classnames"));
var _array = require("../../utils/type-checks/array");
var _string = require("../../utils/type-checks/string");
var _parsePaths = require("../../utils/routing/parsePaths.js");
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const merge = require("deepmerge"),
  LinkRouter = props => {
    return /*#__PURE__*/_react.default.createElement(_material.Link, _extends({}, props, {
      component: _reactRouterDom.Link
    }));
  };

/**
 * Breadcrumbs Display
 *
 * @visibleName Route Breadcrumbs
 * @author [Jeff Stevens](mailto:jeffrey.stevens@pheaa.org)
*/
const RouteBreadcrumbs = props => {
  const {
      alternatePage,
      backgroundColor,
      breadcrumbLabelMap,
      className,
      customTheme = {},
      isOverlay = false,
      overlayOpacity = 0.7,
      rootLabel = "Home",
      styles = {},
      testId
    } = props,
    location = (0, _reactRouterDom.useLocation)(),
    pathnames = location.pathname.split("/").filter(x => x),
    theme = merge((0, _styles.useTheme)(), customTheme),
    backgroundValue = backgroundColor ? backgroundColor : theme.breadcrumb.backgroundColor,
    overlayValue = isOverlay && overlayOpacity >= 0 && overlayOpacity <= 1 ? overlayOpacity : 1,
    containerStyles = merge(theme.mixins.container.outer, {
      left: isOverlay ? "0" : "auto",
      paddingBottom: "1rem",
      paddingTop: "1rem",
      position: isOverlay ? "absolute" : "static",
      right: isOverlay ? "0" : "auto",
      top: isOverlay ? "0" : "auto",
      "&.breadcrumbs__container--isNotOverlay": {
        backgroundColor: backgroundValue
      },
      "&.breadcrumbs__container--isOverlay": {
        backgroundColor: `color-mix(in srgb, ${backgroundValue}, transparent ${Math.round((1 - overlayValue) * 100)}%)`
      }
    }),
    innerBoxStyles = merge(theme.mixins.container.inner, {
      alignItems: "center",
      display: "flex",
      justifyContent: "center",
      minHeight: "5.7rem"
    }),
    linkStyles = {
      color: theme.breadcrumb.color,
      fontFamily: theme.breadcrumb.fontFamily.default,
      fontSize: theme.breadcrumb.fontSize,
      textDecoration: "none",
      "&:hover,&:active,&:focus-visible": {
        color: theme.breadcrumb.colorHover,
        textDecoration: "underline"
      }
    },
    textStyles = {
      color: theme.breadcrumb.color,
      fontFamily: theme.breadcrumb.fontFamily.last,
      fontSize: theme.breadcrumb.fontSize
    },
    wrapStyles = merge({
      margin: isOverlay ? "0" : {
        xs: `0 0 ${theme.contentSpacing.mobileHeader}`,
        md: `0 0 ${theme.contentSpacing.desktopHeader}`
      },
      maxHeight: "0",
      maxWidth: "100%",
      minWidth: theme.minWidth,
      padding: "0",
      position: isOverlay ? "relative" : "static",
      width: "100%"
    }, styles),
    routeData = (0, _react.useContext)(_contexts.RouteDataContext),
    defaultBreadcrumbLabelMap = (0, _react.useRef)((0, _parsePaths.parsePaths)(routeData)),
    internalCrumbMap = breadcrumbLabelMap ? breadcrumbLabelMap : defaultBreadcrumbLabelMap.current,
    customClasses = (0, _classnames.default)({
      "breadcrumbs": true,
      [`${className}`]: className
    }),
    customContainerClasses = (0, _classnames.default)({
      "breadcrumbs__container": true,
      "breadcrumbs__container--isOverlay": isOverlay,
      "breadcrumbs__container--isNotOverlay": !isOverlay
    });
  let viewBreadcrumbs = [];
  if (alternatePage) {
    viewBreadcrumbs.push(/*#__PURE__*/_react.default.createElement(_material.Typography, {
      key: alternatePage,
      sx: textStyles,
      component: "span"
    }, alternatePage));
  } else {
    pathnames.forEach((value, index) => {
      const last = index === pathnames.length - 1,
        to = `/${pathnames.slice(0, index + 1).join("/")}`;
      if ((0, _string.isStringOfLength)(internalCrumbMap[to])) {
        viewBreadcrumbs.push(last ? /*#__PURE__*/_react.default.createElement(_material.Typography, {
          sx: textStyles,
          key: to,
          component: "span"
        }, internalCrumbMap[to]) : /*#__PURE__*/_react.default.createElement(LinkRouter, {
          sx: linkStyles,
          to: to,
          key: to
        }, internalCrumbMap[to]));
      }
    });
  }
  return (0, _array.isArrayOfLength)(viewBreadcrumbs) && /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: customClasses,
    id: "breadcrumb-wrap",
    sx: wrapStyles,
    "data-testid": testId
  }, /*#__PURE__*/_react.default.createElement(_material.Container, {
    className: customContainerClasses,
    sx: containerStyles,
    "data-testid": testId ? `${testId}__container` : undefined
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: innerBoxStyles
  }, /*#__PURE__*/_react.default.createElement(_material.Breadcrumbs, {
    "aria-label": "Breadcrumb Navigation",
    component: "nav",
    sx: {
      ".MuiBreadcrumbs-ol": {
        justifyContent: "center"
      }
    },
    separator: /*#__PURE__*/_react.default.createElement(_NavigateNext.default, {
      fontSize: theme.breadcrumb.fontSize,
      sx: {
        color: theme.breadcrumb.color,
        position: "relative",
        top: "0.2rem"
      }
    })
  }, /*#__PURE__*/_react.default.createElement(LinkRouter, {
    sx: linkStyles,
    to: "/"
  }, rootLabel), viewBreadcrumbs))));
};

// Define propTypes;
RouteBreadcrumbs.propTypes = {
  /** String to override breadcrumb for alternate page name*/
  alternatePage: _propTypes.default.string,
  /** Custom background color, defaults to theme.breadcrumb.backgroundColor */
  backgroundColor: _propTypes.default.string,
  /** Array of Links to be output, available through parent context by default */
  breadcrumbLabelMap: _propTypes.default.object,
  /** Custom classnames */
  className: _propTypes.default.string,
  /** Theme injection object (Default Value: {}) */
  customTheme: _propTypes.default.object,
  /** Boolean to enable/disable overlay behavior (Default Value: false) */
  isOverlay: _propTypes.default.bool,
  /** Opacity for breadcrumb overlays, between 0 and 1 (Default Value: 0.7) */
  overlayOpacity: _propTypes.default.number,
  /** String label for Home/Root path (Default Value: "Home") */
  rootLabel: _propTypes.default.string,
  /** Custom styles object (Default Value: {}) */
  styles: _propTypes.default.object,
  /** @ignore */
  testId: _propTypes.default.string
};

// Export component as default;
var _default = exports.default = RouteBreadcrumbs;